import axios from "axios";
import { GenericResponse, JwtPayload, LoginRequest, LoginResponse, RegisterUserCommand, UserDetailResponse, UserResponse } from "../types/AuthTypes";
import axiosInstance from "./axiosInstance";
import { jwtDecode } from "jwt-decode";

const API_URL = process.env.REACT_APP_API_URL;

export const login = async (credentials: LoginRequest): Promise<LoginResponse | null> => {
  try {
    const response = await axios.post<LoginResponse>(`${API_URL}/users/signin`, credentials, {
      withCredentials: true,
    });

    const { data } = response.data;
    localStorage.setItem("accessToken", data.accessToken);
    localStorage.setItem("refreshToken", data.refreshToken);

    return response.data;
  } catch (error) {
    console.error("Login failed", error);
    return null;
  }
};

export const logout = async (): Promise<void> => {
  try {
    await axiosInstance.post(`${API_URL}/users/signout`, {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      withCredentials: true,
    });
  } catch (error) {
    console.error("Logout error", error);
  } finally {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }
};

export const refreshToken = async (): Promise<string | null> => {
  try {
    const response = await axios.post<LoginResponse>(`${API_URL}/users/refresh-token`, {
      accessToken: localStorage.getItem("accessToken"),
      refreshToken: localStorage.getItem("refreshToken"),
    });

    const { data } = response.data;
    localStorage.setItem("accessToken", data.accessToken);
    localStorage.setItem("refreshToken", data.refreshToken);
    return data.accessToken;
  } catch (error) {
    console.error("Refresh token failed", error);
    logout();
    return null;
  }
};

export const getUserRole = (): string | null => {
    const token = localStorage.getItem("accessToken");
    if (!token) return null;
    const decoded: JwtPayload = jwtDecode(token);
    return decoded.role;
};

export const registerUser = async (request: RegisterUserCommand): Promise<GenericResponse | null> => {
    try {
        const response = await axiosInstance.post<GenericResponse>(`${API_URL}/users/register`, request, {
            withCredentials: true,
        });

        const { isError } = response.data;
        if (isError) {
            return response.data;
        }

        return response.data;
    } catch (error) {
        console.error("Failed to register user", error);
        return null;
    }
}

export const getAllUsers = async (): Promise<UserResponse[]> => {
  try {
      const response = await axiosInstance.get(`${API_URL}/users`, {
          withCredentials: true,
      });

      return response.data;
  } catch (error) {
      console.error("Failed to fetch users", error);
      return [];
  }
}

export const deleteUser = async (id: number): Promise<void> => {
  try {
      await axiosInstance.delete(`${API_URL}/users/?id=${id}`, {
          withCredentials: true,
        });
  } catch (error) {
      console.error("Error deleting user:", error);
  }
};

export const getUserById = async (id: string): Promise<UserDetailResponse | null> => {
  try {
    const response = await axiosInstance.get<UserDetailResponse>(`${API_URL}/users/${id}`, {
        withCredentials: true,
      });
    return response.data;
  } catch (error) {
    console.error("Error fetching family:", error);
    return null;
  }
}

export const updateUser  = async (request: UserDetailResponse) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/users`, request, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    return null;
  }
}
